import moment from "moment/moment";

/**
 * Reglas comunes a los reportes de seguimiento del gestor: como leer las horas que manda
 * el servidor y cuando una señal se considera viva. Estan aparte porque el recorrido de un
 * dia y el mapa de todos los gestores tienen que juzgar lo mismo de la misma forma: si un
 * reporte dijera "en linea" y el otro "sin señal" para el mismo punto, no habria forma de
 * saber a cual creerle.
 */

// Las horas llegan ya convertidas a hora de Nicaragua y sin zona. Para medir "hace cuanto"
// hay que fijarles esa zona: si el navegador estuviera configurado en otra, la antiguedad
// saldria corrida por horas enteras.
export const ZONA_NICARAGUA = "-06:00";

export const ahoraEnNicaragua = () => moment().utcOffset(ZONA_NICARAGUA);

export const hoyEnNicaragua = () => ahoraEnNicaragua().format("YYYY-MM-DD");

export const minutosDesde = (capturedAt) =>
  ahoraEnNicaragua().diff(
    moment.parseZone(`${capturedAt}${ZONA_NICARAGUA}`),
    "minutes"
  );

export const formatearMinutos = (minutos) => {
  if (minutos < 60) {
    return `${minutos} min`;
  }
  return `${Math.floor(minutos / 60)}h ${minutos % 60}m`;
};

export const haceCuanto = (minutos) =>
  minutos <= 1 ? "hace instantes" : `hace ${formatearMinutos(minutos)}`;

/**
 * Hasta cuando se considera viva la señal. El telefono manda un latido cada 15 minutos
 * aunque el gestor no se haya movido, asi que pasados 20 ya hay algo que revisar; de una
 * hora en adelante lo que se ve es por donde anduvo, no donde esta.
 */
export const MINUTOS_SENAL_VIVA = 20;
export const MINUTOS_SENAL_TIBIA = 60;

export const estadoSenal = (minutos) => {
  if (minutos <= MINUTOS_SENAL_VIVA) {
    return { color: "#00a152", chip: "success", viva: true };
  }
  if (minutos <= MINUTOS_SENAL_TIBIA) {
    return { color: "#ed6c02", chip: "warning", viva: false };
  }
  return { color: "#757575", chip: "default", viva: false };
};

// Cada cuanto se vuelve a consultar con el seguimiento en vivo encendido. El telefono
// captura cada minuto, asi que pedir mas seguido solo repetiria la misma respuesta.
export const REFRESCO_MS = 60 * 1000;

// Managua, para centrar el mapa cuando todavia no hay datos que mostrar.
export const CENTRO_POR_DEFECTO = [12.1364, -86.2514];

export const RECORRIDO = 0;

export const EVENTOS = {
  1: { etiqueta: "Abono", color: "#00a152", chip: "success" },
  2: { etiqueta: "Cliente nuevo", color: "#2979ff", chip: "primary" },
  3: { etiqueta: "Crédito nuevo", color: "#7b1fa2", chip: "secondary" },
  7: { etiqueta: "Desembolso", color: "#ed6c02", chip: "warning" },
};

/**
 * Momentos en que el seguimiento no pudo capturar. Se enumeran una por una y no por
 * rango: el rango daba por hecho que todo tipo nuevo sería una incidencia, y el
 * desembolso —que es un hito y quedó en el 7— habría salido en el mapa como un corte.
 * Debe coincidir con PositionKindExtensions.EsIncidencia del backend.
 */
export const INCIDENCIAS = [4, 5, 6];

export const esIncidencia = (punto) => INCIDENCIAS.includes(punto.kind);

/** Ultimo punto del que se conoce el lugar, sea de recorrido, un hito o una incidencia. */
export const ultimoConocido = (puntos) => {
  for (let i = puntos.length - 1; i >= 0; i -= 1) {
    if (puntos[i].latitude !== null) {
      return puntos[i];
    }
  }
  return null;
};
